import { IDynamicTableParams } from 'components/DynamicTable';
import instance from 'api';

// Объекты (ЖК) с геоконтролем. Контроллер chronaObject на бэке.
export const getObjects = (filters: IDynamicTableParams) =>
  instance()
    .post('chronaObject/report', filters)
    .then((response) => response.data);

export const getAvailableColumns = () =>
  instance()
    .post('chronaObject/availableColumns')
    .then((response) => response.data);

export const getFilterColumns = () =>
  instance()
    .post('chronaObject/availableGroupColumns')
    .then((response) => response.data);

/** Тумблер геоконтроля по одному объекту. */
export const toggleGeoControl = (realEstateGuid: string, active: boolean) =>
  instance()
    .post('chronaObject/save', { realEstateGuid, isGeoControlActive: active })
    .then((response) => response.data);

/**
 * Сколько объектов попадёт под массовое переключение. Спрашиваем до применения: действие
 * необратимо одной кнопкой, и админ должен видеть охват, а не узнавать его из результата.
 */
export const bulkPreview = (target: IBulkTarget) =>
  instance()
    .post('chronaObject/bulkPreview', target)
    .then((response) => response.data as number);

/**
 * Массовое переключение геоконтроля по отмеченным объектам либо по текущему набору фильтров реестра (ТЗ 3.2).
 * `isGeoControlActive: false` — откат пилота: выключить геоконтроль на выбранных объектах.
 */
export const bulkSetGeoControl = (target: IBulkTarget, isGeoControlActive: boolean) =>
  instance()
    .post('chronaObject/bulkActivate', { ...target, isGeoControlActive })
    .then((response) => response.data as number);

/** Кого переключать: отмеченные объекты (приоритет на бэке) либо всё под фильтрами реестра. */
export interface IBulkTarget {
  realEstateGuids?: string[];
  filterColumns?: any[];
}

export interface IDeletePreview {
  realEstateGuid: string;
  realEstateName: string;
  isGeoControlActive: boolean;
  /** Должностей в геозоне — исчезнут вместе с объектом. */
  positionCount: number;
  /** Активных назначений сотрудников — будут сняты. */
  assignmentCount: number;
  /** Отметок по объекту — останутся в реестре визитов. */
  checkInCount: number;
  firstCheckInAt: string | null;
  lastCheckInAt: string | null;
}

/**
 * Что потеряется при удалении объекта. Удаление физическое и без восстановления, поэтому
 * охват спрашиваем до подтверждения — числа уходят прямо в текст диалога.
 */
export const deleteObjectPreview = (realEstateGuid: string) =>
  instance()
    .post('chronaObject/deletePreview', { realEstateGuid })
    .then((response) => response.data as IDeletePreview);

export const deleteObject = (realEstateGuid: string) =>
  instance()
    .post('chronaObject/delete', { realEstateGuid })
    .then((response) => response.data);
